<template>

  <div
    :id="`likeable_${pluginType}_${plugin.id}`"
    :class="`likeable_item likeable_${pluginType} ${statusClass}`"
    v-show="plugin.is_likeable
  ">
    <!-- Title -->
    <span v-show="pageType !== 'Attendee Detail'" class="likeable_title">{{plugin.likeable_title}}</span>

    <div class="likeable_inner_wrapper">
      <div class="likeable_buttons">
        <!-- Like Button -->
        <div :class="{'active': isLiked}">
          <div @click="toggleLike('like')" class="likeable_button like_button">
            <i class="far fa-thumbs-up likeable_icon"></i>
            <span class="like_button_text">
              {{pageType !== 'Attendee Detail' ? plugin.like_button_text : ''}}
            </span>
          </div>
        </div>
        <!-- Dislike Button -->
        <div :class="{'active': isDisliked}">
          <div @click="toggleLike('dislike')" class="likeable_button dislike_button">
            <i class="far fa-thumbs-down likeable_icon"></i>
            <span class="dislike_button_text">
              {{pageType !== 'Attendee Detail' ? plugin.dislike_button_text : ''}}
            </span>
          </div>
        </div>
      </div>
      <!-- Survey Button -->
      <div class="survey_button_wrapper" v-if="plugin.survey_id">
        <div v-if="like">
          <a @click="triggerSurvey()" class="likeable_survey_button" v-html="surveyButtonText"></a>
          <survey-popup
            v-if="surveyActive"
            :key="plugin.id"
            :survey-id="surveyId"
            :plugin-id="plugin.id"
            :plugin-type="pluginType"
            :is-active="surveyActive"
            @toggle="triggerSurvey"
            :class="{'is_active':surveyActive}"
          ></survey-popup>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {

    props: {
      pluginType: {
        type: String,
        required: true
      },
      plugin: {
        type: Object
      },
      pageType: {
        type: String
      }
    },

    data() {
      return {
        like: this.plugin.like,
        surveyId: this.plugin.survey_id,
        surveyActive: false
      }
    },
    
    computed: {
     isLiked: function() {
      return this.like ? this.like.status === 'like' : false
     },
     isDisliked: function() {
      return this.like ? this.like.status === 'dislike' : false
     },
     statusClass: function() {
      return this.isLiked ? 'liked' : this.isDisliked ? 'disliked' : '';
     },
     surveyButtonText: function() {
      if ($('.baseEvent').length) {
        return this.plugin.survey_button_text ? this.plugin.survey_button_text : 'Provide Feedback';
      } else {
        return this.plugin.survey_button_text;
      }
     }
    },

    methods: {
      removeLike: function() {
        var self = this
        axios.delete(`/likeables/${this.like.id}`, {})
          .then(response => {
            self.like = null
            self.emitLike()
          })
          .catch(error => {
            console.log(error)
          })
      },
      updateLike: function(status) {
        var self = this

        axios.patch(`/likeables/${this.like.id}`, {'status': status})
          .then(response => {
            if (response.data.data) {
              self.like = response.data.data
              self.emitLike()
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      createLike: function(status) {
        var self = this

        var likeableObj = {
          'likeable_id': this.plugin.id,
          'likeable_type': this.pluginType,
          'status': status
        }

        axios.post('/likeables', likeableObj)
          .then(response => {
            if (response.data.data) {
              self.like = response.data.data
              self.emitLike()
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      toggleLike: function(status) {
        var self = this

        if (this.like) {
          if (self.like.status === status) {
            self.removeLike()
          } else {
            self.updateLike(status)
          }
        } else {
          self.createLike(status)
        }
      },
      emitLike: function() {
        this.plugin.like = this.like
        if (this.pluginType === 'VideoAsset') {
          window.EventBus.$emit('video-asset-likeable-toggle', this.plugin);
        }
      },
      triggerSurvey: function() {
        this.closeAllPopupsExceptThis(this.plugin.id)
        this.$nextTick(()=>{
          this.surveyActive = !this.surveyActive
          this.$forceUpdate()
        })
      },
      closeAllPopupsExceptThis: function(omit) {
        EventBus.$emit('close-survey-popup', omit)
      },
      handleCloseAllPopupsExceptThis: function(omit) {
        var self = this
        if (self.plugin.id != omit){
          self.surveyActive = false
        }
      }
    },
    created() {
      EventBus.$on('close-survey-popup', this.handleCloseAllPopupsExceptThis)
    },
    beforeDestroy() {
      EventBus.$off('close-survey-popup')
    }
}

</script>

<style scoped>
  .likeable_item {
    margin-top: 15px;
    position: relative;
  }
  .likeable_buttons {
    display: inline-flex;
  }
  .agenda .likeable_inner_wrapper {
    display: flex;
  }
  .agenda .likeable_buttons {
    flex-direction: column;
  }
  .likeable_button {
    border: thin solid;
    border-radius: 25px;
    line-height: 35px;
    padding: 0 1rem;
    margin: .25rem;
    margin-left: 0;
    /* Disable text highlighting */
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .disliked .survey_button_wrapper {
    align-self: end;
  }
  .video-asset-likes .likeable_survey_button {
    display: block;
    text-align: center;
  }
  .likeable_survey_button {
    font-weight: 500;
    padding-left: 10px;
  }
  .likeable_survey_button:hover {
      text-decoration: none;
  }
  .likeable_button:hover {
    box-shadow: 2px 2px 10px 0px rgb(0 0 0 / 20%);
   /* transform: translate(0px, -3px) perspective(1px) translateZ(0);*/
    backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
    cursor: pointer;
  }
  .likeable_title {
    display: block;
    margin-bottom: .75rem;
  }
  .customEvent .liked :not(.active) > .likeable_button,
  .customEvent .disliked :not(.active) > .likeable_button {
    opacity: .25;
  }
  .active > .likeable_button {
    border: none;
  }
  .active > .like_button {
    color: #008AFF;
    background: rgb(0 138 255 / 10%);
  }
  .active > .dislike_button {
    color: #dc3545;
    background: rgb(220 53 69 / 10%);
  }
  .customEvent .likeable_icon {
    margin-right: .5rem;
  }

  .directory-detail-speakers-sessions .likeable_icon {
    margin-right: 0px;
  }
  .active .likeable_icon {
    font-weight: 900;
  }
  /* Base Event Styling */
  .baseEvent .likeable_inner_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .baseEvent .like_button_text, .baseEvent .dislike_button_text {
    display: none;
  }
  .baseEvent .likeable_button {
    display: flex;
    width: 35px;
    height: 35px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    color: var(--theme-secondary-color);
    background-color: var(--theme-secondary-text-color);
    border: 1px solid var(--theme-secondary-color);
  }
  .baseEvent .likeable_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0;
    gap: 10px;
  }
  .baseEvent .likeable_buttons {
    flex-direction: row;
  }
  .baseEvent .likeable_buttons .active > .likeable_button {
    color: var(--theme-primary-text-color);
    background: var(--theme-secondary-color);
  }
  .baseEvent .likeable_title {
    margin: 0;
  }
</style>